import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 3.2rem;

  margin-top: 1.8rem;
  margin-left: 14rem;
`;

export { Container };
